import styled from 'styled-components';

const StyledThinkingSpaceCluster = styled.div`
  /* Styles go here */
`;

export default StyledThinkingSpaceCluster;
